import { render, staticRenderFns } from "./OperaFieldTypeDataWindow.vue?vue&type=template&id=5388e251&"
import script from "./OperaFieldTypeDataWindow.vue?vue&type=script&lang=js&"
export * from "./OperaFieldTypeDataWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaFieldTypeDataWindow.vue?vue&type=style&index=0&id=5388e251&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports